<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  name?: string
  size?: 'sm' | 'md' | 'lg' | 'xl'
}>()

const initials = computed(() => {
  if (!props.name) return '?'
  const words = props.name.trim().split(/\s+/)
  if (words.length === 1) {
    return words[0].charAt(0).toUpperCase()
  }
  return (words[0].charAt(0) + words[words.length - 1].charAt(0)).toUpperCase()
})

const stringToColor = (str: string): string => {
  const colors = [
    '#3B82F6', // blue
    '#10B981', // emerald
    '#8B5CF6', // violet
    '#F59E0B', // amber
    '#EF4444', // red
    '#EC4899', // pink
    '#06B6D4', // cyan
    '#84CC16', // lime
    '#F97316', // orange
    '#6366F1', // indigo
    '#14B8A6', // teal
    '#A855F7', // purple
  ]

  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }

  return colors[Math.abs(hash) % colors.length]
}

const backgroundColor = computed(() => stringToColor(props.name || ''))

const sizeClass = computed(() => {
  switch (props.size) {
    case 'sm':
      return 'w-[32px] h-[32px] text-[12px]'
    case 'lg':
      return 'w-[48px] h-[48px] text-[16px]'
    case 'xl':
      return 'w-[80px] h-[80px] text-[28px]'
    default:
      return 'w-[40px] h-[40px] text-[14px]'
  }
})
</script>

<template>
  <div
    class="flex items-center justify-center rounded-full text-white font-medium shrink-0"
    :class="sizeClass"
    :style="{ backgroundColor }"
  >
    {{ initials }}
  </div>
</template>
